import { Steps, Variant, VariantB, VariantC } from '../../types'
import * as Styles from './styles'

interface IProps {
  variant: Variant
  nextStep?: Steps
  prevStep?: Steps
  activeStep: Steps
  backButtonText?: string
  continueButtonText?: string
  setStep: (step: Steps) => void
  onFinish?: () => void
}

export const StepsActions = ({
  variant,
  nextStep,
  activeStep,
  prevStep,
  backButtonText,
  continueButtonText,
  setStep,
  onFinish,
}: IProps) => {
  const stepsType = variant === 'b' ? VariantB : VariantC
  const steps = Object.values(stepsType).map(item => item)

  const onNextStep = () => {
    if (nextStep) {
      setStep(nextStep)
    } else {
      onFinish?.()
    }
  }

  const onPreviousStep = () => {
    if (!prevStep) return
    setStep(prevStep)
  }

  return (
    <Styles.Container data-testid="steps-actions">
      <Styles.StepsCounter data-testid="steps-counter">
        {steps.map((step: Steps) => (
          <Styles.Step
            key={step}
            active={step === activeStep}
            data-testid={`step-indicator-${step}`}
          />
        ))}
      </Styles.StepsCounter>
      <Styles.Actions data-testid="steps-buttons">
        {prevStep && (
          <Styles.BackButton onClick={onPreviousStep} data-testid="back-button">
            {backButtonText || 'Back'}
          </Styles.BackButton>
        )}
        <Styles.ContinueButton onClick={onNextStep} data-testid="continue-button">
          {continueButtonText || 'Continue'}
        </Styles.ContinueButton>
      </Styles.Actions>
    </Styles.Container>
  )
}
